import { useDms } from '../configuration/useDms';

export function useRating(ratingName: string) {
  const dms = useDms();

  return dms.ratingNameMap.get(ratingName);
}
